// @flow
import React from "react"
import { hot } from "react-hot-loader"
import { Wrapper } from "./style"
import { tRouteProps, tSiteProps } from "../../types"
import { Container } from "../StyledComponents"
import { EnvelopeIcon } from "../Icons/EnvelopeIcon"
import { PhoneIcon } from "../Icons/PhoneIcon"
import { Form } from "./Form"
import { css } from "react-emotion"
import { color } from "../../styles/variables"

type tFooter = {
  routeProps: tRouteProps & tSiteProps
}

function FooterInner(props: tFooter) {
  const { brand } = props.routeProps
  return (
    <Wrapper>
      <Container className="main-container">
        <div className="brand-container">
          <div className="brand-left">
            <div className="brand-left-top">
              <div className="logo-wrapper">
                <img
                  src={brand.logo.url}
                  alt={brand.logo.alt}
                  className="logo"
                />
              </div>
              <p className="logo-description">{brand.logo_description}</p>
            </div>
          </div>
          <div className="brand-right">
            <div className="newsletter">
              <Form {...brand.newsletter_form} />
            </div>
          </div>
        </div>
      </Container>
      <div className="contact">
        <Container>
          <div>
            <h4>Address</h4>
            {brand.contact.contact_address.map((item) => (
              <p key={item.line}>{item.line}</p>
            ))}

            <p>
              <a className="link-w-icon" href={`mailto:${brand.contact.email}`}>
                <span className="icon-wrapper">
                  <EnvelopeIcon />
                </span>
                {brand.contact.email}
              </a>
            </p>
            <p>
              <a
                className="link-w-icon"
                href={`tel:${brand.contact.phone.url}`}
              >
                <span className="icon-wrapper">
                  <PhoneIcon />
                </span>
                {brand.contact.phone.label}
              </a>
            </p>
          </div>
          <div>
            <h4>Services &amp; Events</h4>
            {brand.contact.address.map((item) => (
              <p key={item.line}>{item.line}</p>
            ))}
          </div>
          <div>
            <div className="social">
              {brand.social.map((item) => (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={item.url}
                  key={item.name}
                  className={item.name.toLowerCase()}
                >
                  <img src={item.icon} alt={item.name} />
                </a>
              ))}
            </div>
            <p
              className={css`
                text-transform: uppercase;
                a {
                  color: ${color.rgb.white[0]};
                }
              `}
            >
              <a href="/privacy-policy/">Privacy Policy</a>
            </p>
            <p>
              Copyright &copy; {new Date().getFullYear()} Center for Spiritual
              Living
            </p>
          </div>
        </Container>
      </div>
    </Wrapper>
  )
}

export const Footer = hot(module)(FooterInner)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Footer/index.js